import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../job-board.css';
import { jbApi } from '../api';
import { useJBAuth } from '../auth';

export default function EmployerAuthPage({ initialTab = 'login' }) {
  const navigate = useNavigate();
  const { login } = useJBAuth();
  const [tab, setTab]         = useState(initialTab);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const [loginForm, setLoginForm] = useState({ email:'', password:'' });
  const [regForm, setRegForm]     = useState({
    company_name:'', contact_name:'', contact_email:'',
    password:'', industry:'', website_url:'', company_bio:'',
  });

  const setL = k => e => setLoginForm(p => ({ ...p, [k]: e.target.value }));
  const setR = k => e => setRegForm(p => ({ ...p, [k]: e.target.value }));

  async function handleLogin(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await jbApi.employerLogin({ email: loginForm.email, password: loginForm.password });
      const me  = await jbApi.me(res.access_token);
      login(res.access_token, res.role, me.profile);
      navigate('/employer/dashboard');
    } catch (err) {
      setError(err.detail || 'Invalid credentials');
    } finally { setLoading(false); }
  }

  async function handleRegister(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await jbApi.employerRegister({
        company_name:  regForm.company_name,
        contact_name:  regForm.contact_name,
        contact_email: regForm.contact_email,
        password:      regForm.password,
        industry:      regForm.industry || undefined,
        website_url:   regForm.website_url || undefined,
        company_bio:   regForm.company_bio || undefined,
      });
      const me = await jbApi.me(res.access_token);
      login(res.access_token, res.role, me.profile);
      navigate('/employer/dashboard');
    } catch (err) {
      setError(err.detail || 'Registration failed. Please try again.');
    } finally { setLoading(false); }
  }

  return (
    <div className="jb-page" style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'80vh', padding:20 }} data-testid="employer-auth-page">
      <div style={{ width:'100%', maxWidth:480 }}>

        {/* Header */}
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <Link to="/career-hub" style={{ fontSize:12, color:'#1B6B72', fontWeight:700, textDecoration:'none', letterSpacing:'.08em', textTransform:'uppercase' }}>
            ← Career Hub
          </Link>
          <h1 style={{ fontFamily:'Inter,sans-serif', fontSize:26, fontWeight:800, color:'#0D2137', margin:'12px 0 4px' }}>Employer Portal</h1>
          <p style={{ fontSize:14, color:'#5a6373', margin:0 }}>Post jobs. Find your next hire.</p>
        </div>

        <div style={{ background:'#fff', borderRadius:14, boxShadow:'0 4px 24px rgba(13,33,55,.1)', padding:28 }}>
          {/* Tabs */}
          <div className="jb-tabs">
            <button className={`jb-tab${tab==='login'?' active':''}`} onClick={() => { setTab('login'); setError(''); }} data-testid="tab-employer-login">Log In</button>
            <button className={`jb-tab${tab==='register'?' active':''}`} onClick={() => { setTab('register'); setError(''); }} data-testid="tab-employer-register">Create Account</button>
          </div>

          {error && <div className="jb-error-box" data-testid="employer-auth-error">{error}</div>}

          {/* Login */}
          {tab === 'login' && (
            <form onSubmit={handleLogin} data-testid="employer-login-form">
              <div className="jb-form-group">
                <label className="jb-form-label">Email</label>
                <input className="jb-form-input" type="email" required value={loginForm.email} onChange={setL('email')} placeholder="contact@company.com" data-testid="employer-email" />
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Password</label>
                <input className="jb-form-input" type="password" required value={loginForm.password} onChange={setL('password')} placeholder="••••••••" data-testid="employer-password" />
              </div>
              <button className="jb-btn-primary" type="submit" disabled={loading} data-testid="employer-login-submit">
                {loading ? 'Logging in…' : 'Log In to Dashboard'}
              </button>
            </form>
          )}

          {/* Register */}
          {tab === 'register' && (
            <form onSubmit={handleRegister} data-testid="employer-register-form">
              <div className="jb-form-row">
                <div className="jb-form-group">
                  <label className="jb-form-label">Company Name *</label>
                  <input className="jb-form-input" required value={regForm.company_name} onChange={setR('company_name')} placeholder="Acme Corporation" data-testid="reg-company-name" />
                </div>
                <div className="jb-form-group">
                  <label className="jb-form-label">Contact Name *</label>
                  <input className="jb-form-input" required value={regForm.contact_name} onChange={setR('contact_name')} placeholder="Jane Smith" data-testid="reg-contact-name" />
                </div>
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Work Email *</label>
                <input className="jb-form-input" type="email" required value={regForm.contact_email} onChange={setR('contact_email')} placeholder="jane@company.com" data-testid="reg-email" />
              </div>
              <div className="jb-form-row">
                <div className="jb-form-group">
                  <label className="jb-form-label">Industry</label>
                  <input className="jb-form-input" value={regForm.industry} onChange={setR('industry')} placeholder="Technology" data-testid="reg-industry" />
                </div>
                <div className="jb-form-group">
                  <label className="jb-form-label">Website</label>
                  <input className="jb-form-input" type="url" value={regForm.website_url} onChange={setR('website_url')} placeholder="https://company.com" data-testid="reg-website" />
                </div>
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Password *</label>
                <input className="jb-form-input" type="password" required minLength={8} value={regForm.password} onChange={setR('password')} placeholder="Min. 8 characters" data-testid="reg-password" />
              </div>
              <button className="jb-btn-primary" type="submit" disabled={loading} data-testid="employer-register-submit">
                {loading ? 'Creating account…' : 'Create Employer Account'}
              </button>
            </form>
          )}
        </div>

        <p style={{ textAlign:'center', fontSize:12, color:'#94a3b8', marginTop:16 }}>
          Looking for a job? <Link to="/seeker/login" style={{ color:'#1B6B72', fontWeight:600 }}>Job seeker portal →</Link>
        </p>
      </div>
    </div>
  );
}
